import React from 'react';

const AnchorLink = (props: React.HTMLProps<HTMLAnchorElement>) => {
  return (
    <a aria-label="Product link" {...props} rel="noreferrer" target="_blank" />
  );
};

export default AnchorLink;
